import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { logoutSecureUpload } from '@/api/secure-upload/secure-upload-module'
import { useAlert } from '@/utils/use-alert'

export function useSecureLogout() {
  const store = useStore()
  const router = useRouter()

  const logout = async () => {
    // Show loader (main app convention)
    store.commit('globalComponents/setIsLoadingApp', true)
    try {
      // Clear session
      logoutSecureUpload(store)
      // Show alert
      useAlert({ type: 'success', title: 'Logged Out', message: 'You have successfully logout.' })
      // Redirect to login page
      await router.push('/secure-upload')
    } finally {
      store.commit('globalComponents/setIsLoadingApp', false)
    }
  }

  return { logout }
}
